import { render, staticRenderFns } from "./MenuNavigation.vue?vue&type=template&id=4bebf537&scoped=true"
import script from "./MenuNavigation.vue?vue&type=script&lang=js"
export * from "./MenuNavigation.vue?vue&type=script&lang=js"
import style0 from "./MenuNavigation.vue?vue&type=style&index=0&id=4bebf537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bebf537",
  null
  
)

export default component.exports